import React from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import { useTranslation } from 'react-i18next';

import { post_reservation } from '../api/reservaton';
import { ActivityModal } from '../components/Modal';
import { type ReservationConfirmProps } from 'types/ScreenTypes';
import { addDataToInfoMap } from '../utils/Utils';
import { type FinalReservationType } from '../types/Reservation';
import Dialog from '../components/Dialog/Dialog';
import {
    NOT_AVAILABLE_CODE,
    NOT_FOUND_CODE,
    SUCCESS_MESSAGE_CODE,
    VALIDATION_MESSAGE_CODE,
} from '../const/messagesCode';
import { type SubmitReservationType } from 'types/API';
import { Button } from '@rneui/themed';

const styles = StyleSheet.create({
    container: {
        width: '100%',
        padding: 24,
        backgroundColor: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

const ReservationConfirm: React.FC<ReservationConfirmProps> = ({
    navigation,
    route,
}) => {
    const value = route.params;
    const actions = value?.actions;

    const [messageItem, setMessageItem] = React.useState<{
        message_code: number;
        message: string;
    }>({
        message_code: 0,
        message: '',
    });
    const [modalState, setModalState] = React.useState({
        isVisible: false,
        loading: false,
    });

    const { t } = useTranslation();

    const columnInfoMap = {
        name: {
            name: t('name'),
            type: 'text',
        },
        date: {
            name: t('date'),
            type: 'text',
        },
        time: {
            name: t('time'),
            type: 'text',
        },
        people_num: {
            name: t('peopleNumber'),
            type: 'text',
        },
        email: {
            name: t('email'),
            type: 'text',
        },
        tel: {
            name: t('phoneNumber'),
            type: 'text',
        },
        table: {
            name: t('table'),
            type: 'image',
        },
        options: {
            name: t('options'),
            type: 'listText',
        },
        accommodation: {
            name: t('accommodation'),
            type: 'text',
        },
        notes: {
            name: t('notes'),
            type: 'text',
        },
    };

    const handleFinalModal = (): void => {
        setModalState({
            isVisible: false,
            loading: modalState.loading,
        });
        if (messageItem.message_code === SUCCESS_MESSAGE_CODE) {
            actions.resetForm();
            navigation.navigate('Reservation');
        } else if (messageItem.message_code === VALIDATION_MESSAGE_CODE) {
            navigation.navigate('Reservation');
        } else if (
            messageItem.message_code === NOT_FOUND_CODE ||
            messageItem.message_code === NOT_AVAILABLE_CODE
        ) {
            actions.resetForm();
            navigation.navigate('Reservation');
        } else {
            actions.resetForm();
            navigation.navigate('Reservation');
        }
    };

    const afterSubmit = (data: SubmitReservationType): void => {
        console.log(data);
        let message = '';
        if (data?.message_code === SUCCESS_MESSAGE_CODE) {
            message = t('reservationSuccess');
        } else if (data?.message_code === VALIDATION_MESSAGE_CODE) {
            message = 'Validation Error';
        } else if (
            data?.message_code === NOT_FOUND_CODE ||
            data?.message_code === NOT_AVAILABLE_CODE
        ) {
            message = t('reservationAlreadyExists');
        } else {
            message = t('serverError');
        }

        setMessageItem({
            message,
            message_code: data?.message_code,
        });
        setModalState({
            isVisible: true,
            loading: false,
        });
    };

    const onSubmit = (): void => {
        setModalState({
            isVisible: true,
            loading: true,
        });

        const submitValue: FinalReservationType = {
            table_id: value.table.table_id,
            table_type_id: value.table.type_id,
            ...value,
        };
        submitValue.tel = value.tel.replace(/ /g, '-');
        submitValue.options = submitValue.options.map((option) => option?.id);
        console.log(submitValue);
        if ('table' in submitValue) {
            delete (submitValue as any).table;
        }
        void post_reservation(submitValue, afterSubmit);
    };

    return (
        <ScrollView contentContainerStyle={styles.container}>
            <ActivityModal
                modalState={modalState}
                closeFunc={handleFinalModal}
                message={messageItem?.message}
            />
            <Dialog
                data={addDataToInfoMap(value, columnInfoMap)}
                title={t('reservationConfirmation')}
            />
            <Button title={t('reserve')} onPress={onSubmit} />
        </ScrollView>
    );
};

export default ReservationConfirm;
